import { generateRepositoryMethods, } from '../webapp/repository.types.js';
export const prescriptionRepositoryMethods = generateRepositoryMethods({
    deletePrescriptionRequest: {
        callMethod: 'DELETE',
        endpoint: '/prescription-request/delete',
    },
    getAllFailedPrescriptionRequests: {
        callMethod: 'GET',
        endpoint: '/prescription-request/failed/all',
    },
    correctPrescriptionRequest: {
        callMethod: 'POST',
        endpoint: '/prescription-request/correct',
    },
    getPrescriptionRequestsById: {
        callMethod: 'GET',
        endpoint: '/prescription-request/get-by-id',
    },
    getFailedPrescriptionRequestById: {
        callMethod: 'GET',
        endpoint: '/prescription-request/failed/by-id',
    },
    getOpenPrescriptionRequests: {
        callMethod: 'GET',
        endpoint: '/prescription-request/get-open',
    },
    markPrescriptionRequestAsProcessed: {
        callMethod: 'POST',
        endpoint: '/prescription-request/mark-as-processed',
    },
    addPrescriptionRequestComment: {
        callMethod: 'POST',
        endpoint: '/prescription-request/comment',
    },
});
//# sourceMappingURL=prescription.methods.js.map